const classes = {
  main: {
    paddingTop: '3rem'
  }
}

export default classes
